import React, {useEffect, useState} from "react";
import {TranslatedModal} from "../modals";
import {WarningBanner} from "../banners"
import {useDispatch} from "react-redux";
import {ModalBuilder, useAuthState} from "@redriver/cinnamon"
import {getSystemInfo} from "./actions";

export const MisalignedTradeAsError = () => {
    const dispatch = useDispatch();
    const {loggedIn} = useAuthState();
    const [backendValue, setBackendValue] = useState("");
    const [frontendValue, setFrontendValue] = useState("");

    useEffect(() => {
        const checkTradeAsAlignment = async () => {
            const {response} = await dispatch(getSystemInfo());
            setBackendValue(response?.tradeAsIps);
            setFrontendValue(process.env.TRADE_AS_IPS);
        };

        if (loggedIn) {
            checkTradeAsAlignment();
        }
    }, [loggedIn]);

    return (
        <ModalBuilder
            visible={backendValue != null && frontendValue != null && backendValue !== frontendValue}
            renderModal={(modalProps) => (
                <TranslatedModal.Confirmation
                    {...modalProps}
                    className="custom-actions"
                    header=" "
                >
                    <div>
                        <WarningBanner warningText='Misaligned "Trade As IPS" Setting'/>
                        <p style={{fontSize: "1rem", marginTop: "1rem", color: "#333"}}>
                            Your front-end and back-end <strong>"Trade As IPS"</strong> configurations are currently not
                            aligned. Please double-check your environment settings.
                        </p>

                        <div style={{
                            marginTop: "1rem",
                            backgroundColor: "#f9f9f9",
                            padding: "0.75rem",
                            borderRadius: "6px",
                            border: "1px solid #ddd"
                        }}>
                            <p style={{margin: "0.5rem 0", fontFamily: "monospace"}}>
                                <strong>Backend value:</strong> {String(backendValue)}
                            </p>
                            <p style={{margin: "0.5rem 0", fontFamily: "monospace"}}>
                                <strong>Frontend value:</strong> {String(frontendValue)}
                            </p>
                        </div>
                    </div>
                </TranslatedModal.Confirmation>
            )}
        />
    );
};

export default MisalignedTradeAsError;